<!--Start notes component-->
<div class="mvd_alert--container open" *ngIf="showErrorTable">
    <div class="mvd_alert--results" id="errorTable">
        <h2 class="mvd_alert--header">Alerts <button class="close" type="button" (click)="close()">&times;</button></h2>
        <ul class="mvd_alert__group">
            <li class="mvd_alert--error" *ngFor="let e of errors">
                <strong>Error -</strong>
                {{e}}
            </li>
        </ul>
    </div>
</div>

<note-entry *ngIf="showNewNote" [(note)]="newNote" (noteSaved)="onNoteSaved($event)" (noteCancelled)="onNoteCancelled()"></note-entry>

<div class="mvd_container--notes">
    <h2>{{headerText}} <button class="icon--add btn--default" type="button" (click)="toggleNewNote()" *ngIf="!isReadonly && !showNewNote">Notes</button></h2>
    <table class="mvd_table--notes">
        <thead>
            <tr>
                <th>Note</th>
                <th class="w--cust-name">Business Unit</th>
                <th class="w--date-time">Updated</th>
                <th class="w--cust-name">Updated By</th>
                <th class="w--actions-3">Actions</th>
            </tr>
        </thead>
        <tbody *ngIf="!notes.length">
            <tr>
                <td [attr.colspan]="5">
                    No records found
                </td>
            </tr>
        </tbody>
    </table>

    <ng-container *ngIf="notes.length">
        <note-single-view *ngFor="let note of notes" [note]="note" (noteSaved)="onNoteSaved($event)" (noteDeleted)="onNoteDeleted($event)"
                          [isReadonly]="isReadonly" [isAddOnly]="isAddOnly" [isDeleteDisabled]="isDeleteDisabled">
        </note-single-view>
    </ng-container>
</div>